import ZignalyIsotype from "@ui/assets/images/zignaly-isotype.svg";
import ZignalyLogotype from "@ui/assets/images/zignaly-logotype-dark.svg";

// Icons
export const iconsByType = {
  isotype: ZignalyIsotype,
  logotype: ZignalyLogotype,
};

export type LogoProps = {
  type: keyof typeof iconsByType;
  id?: string;
  width?: string;
  height?: string;
};
